import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginService } from 'src/app/services/login.service';
import { MessageService } from 'primeng/api';
import jwt_decode from "jwt-decode";
import { EleicaoService } from 'src/app/services/eleicao.service';
import { Utils } from 'src/app/utils/utils';
import { ComprovanteService } from './../../services/comprovante.service';
import { FormularioPreCandidatoComponent } from '../precandidato/formulario-precandidato.component';
import { FormsModule } from '@angular/forms';
import { Eleicao } from './../../models/eleicao.model';
import { Comprovante } from 'src/app/models/comprovante.model';

@Component({
  selector: 'app-redirecionamento-integracao.',
  templateUrl: './redirecionamento-integracao.component.html',
  styleUrls: ['./redirecionamento-integracao.component.css']
})
export class RedirecionamentoIntegracao implements OnInit {
  informacoesToken: any;
  temIntegracao: any;
  textoSemAcessoCandidatura: any;
  textoSemAcessoVotacao: any;
  textoForaDoPeriodoEleitoral: any;
  textoSessaoExpirada: any;
  idUsuario: any;
  idEleicao: any;
  eleicaoEncerrada: any;
  eleicao: any;
  comprovante: Comprovante[];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public spinner: NgxSpinnerService,
    protected auth: LoginService,
    protected messageService: MessageService,
    protected eleicaoService: EleicaoService,
    private utils: Utils,
    private comprovanteServices: ComprovanteService,
  ) {
  }

  async ngOnInit() {
    this.spinner.show();
    let parametrosRota = this.route.snapshot.params;
    const tokenIntegracao = parametrosRota.token;
    this.auth.decodificarTokenIntegracao(tokenIntegracao).subscribe((result: any) => {
      this.informacoesToken = jwt_decode(result.data);
      sessionStorage.setItem("informacoesToken", this.informacoesToken);
      var statusEleicao = this.informacoesToken.statusEleicao;
      var rotaEleicao = this.informacoesToken.rotaEleicao;
      sessionStorage.setItem("rotaEleicao", rotaEleicao);
      this.getLogoEleicao(rotaEleicao);;;;;
      this.eleicaoService.verifyIntegracao(rotaEleicao).then((res: any) => {
        this.temIntegracao = res.temIntegracao;
        this.textoSemAcessoCandidatura = res.textoSemAcessoCandidatura;
        this.textoSemAcessoVotacao = res.textoSemAcessoVotacao;
        this.textoForaDoPeriodoEleitoral = res.textoForaDoPeriodoEleitoral;
        this.textoSessaoExpirada = res.textoSessaoExpirada;
        sessionStorage.setItem("viaIntegracao", "true");
        if (statusEleicao === "Período de candidatura") {
          sessionStorage.setItem("textoErro", this.textoSemAcessoCandidatura);
          sessionStorage.setItem("sessãoExpirada", this.textoSessaoExpirada);
          this.acessoCandidatura(rotaEleicao);
        } else if (statusEleicao === "Em andamento" || statusEleicao === "Apurada" || statusEleicao === "Encerrada"){
          sessionStorage.setItem("textoErro", this.textoSemAcessoVotacao);
          sessionStorage.setItem("sessãoExpirada", this.textoSessaoExpirada);
          this.acessoEleicao(rotaEleicao);
        } else {
          sessionStorage.setItem("textoErro", this.textoForaDoPeriodoEleitoral);
          this.router.navigate(["../../acesso-negado"], { relativeTo: this.route });
        }
      }).catch(err => {
        console.log(err)
      });
    }, err => {
      console.log(err)
      this.router.navigate(["../../acesso-negado"], { relativeTo: this.route });
    })
  }

  private acessoCandidatura(rotaEleicao: any) {
    this.auth.authenticateAcessoPrecandidato(this.informacoesToken, rotaEleicao).subscribe((result: any) => {
      let token = result.token;
      var candidaturaEncerrada = result.candidaturaEncerrada;
      if (candidaturaEncerrada) {
        sessionStorage.removeItem("textoErro");
        sessionStorage.setItem("textoErro", this.textoForaDoPeriodoEleitoral);
        this.router.navigate(["../../acesso-negado"], { relativeTo: this.route });
      } else {
        var formularioPreenchido = result.formularioPreenchido;
        sessionStorage.setItem("formularioPreenchido", formularioPreenchido);
        sessionStorage.setItem("token", token);
        var decoded = jwt_decode(token);
        sessionStorage.setItem("infoPrecandidato", JSON.stringify(decoded));
        this.router.navigate(['../../' + rotaEleicao + '/confirma'], { relativeTo: this.route });
      }
    }, err => {
      this.router.navigate(["../../acesso-negado"], { relativeTo: this.route });
    });
  }

  private acessoEleicao(rotaEleicao: any) {
    this.auth.authenticateAcessoEleitorIntegracao(this.informacoesToken, rotaEleicao).subscribe((result: any) => {
      let token = result.token;
      this.eleicaoEncerrada = result.eleicaoEncerrada;
      sessionStorage.setItem("eleicaoEncerrada", this.eleicaoEncerrada);
      sessionStorage.setItem("token", token);
      var decoded = jwt_decode(token);
      sessionStorage.setItem("infoEleitor", JSON.stringify(decoded))
      sessionStorage.setItem("rotaEleicao", rotaEleicao)
      this.eleicao = result.eleicao;
      sessionStorage.setItem("eleicao", JSON.stringify(this.eleicao))
      var infoEleitor = JSON.parse(sessionStorage.getItem("infoEleitor"))
      this.idUsuario = infoEleitor.id;
      this.idEleicao = infoEleitor.idEleicao;
      this.getComprovantePorIdLogin(this.idUsuario, this.eleicao, rotaEleicao);
    }, err => {
      this.router.navigate(["../../acesso-negado"], { relativeTo: this.route });
    });
  }

  public getComprovantePorIdLogin(idUsuario: any, eleicao: Eleicao, rotaEleicao: any) {
    var token = sessionStorage.getItem("token")
    this.comprovanteServices.getComprovanteVotoPorIdEleitor(idUsuario, token).then((result: any) => {
      this.comprovante = result;
      if (eleicao.eleicaoEncerrada) {
        //leva ao comprovante e resultado da eleição
        this.spinner.hide();
        this.router.navigate(['../../' + rotaEleicao + '/eleitor/comprovante'], {relativeTo: this.route});
      }
      else{
        this.comprovanteServices.validaCandidatosAVotar(this.idEleicao, this.comprovante, token).then((res: []) => {
          this.spinner.hide();
          if (res.length > 0) {
            this.router.navigate(['../../' + rotaEleicao + '/eleitor/termo'], {relativeTo: this.route});
          } else {
            this.router.navigate(['../../' + rotaEleicao + '/eleitor/comprovante'], {relativeTo: this.route});
          }
        }).catch(err => {
          this.router.navigate(['../../acesso-negado']);
        });
      }
    })
  }

  async getLogoEleicao(rota: string) {
    try {
      const logo = await this.eleicaoService.getLogoByRotaEleicao(rota).toPromise();
      if (logo) {
        this.eleicaoService.logoEleicao = logo;
        sessionStorage.setItem('logoEleicao', logo);
      }
    } catch (error) {
      console.log(error);
    }
  }
}
